import { createAsyncThunk } from '@reduxjs/toolkit'

import { BrokerIdentifiersApi } from '../api/brokerIdentifiersApi'
import {
  BrokerIdentifier,
  BrokerIdentifierList,
  CreateBrokerIdentifierRequest,
  DeleteBrokerIdentifierRequest,
} from '../api/types'

export const SLICE_NAME = 'brokerIdentifiers'

export const GetBrokerIdentifiers = createAsyncThunk<BrokerIdentifierList>(
  `${SLICE_NAME}/getAll`,
  async () => {
    try {
      const response = await BrokerIdentifiersApi.getIdentifiers()
      return response.data
    } catch (error) {
      throw new Error(
        error?.response?.data?.message || error?.message || 'Failed to load identifiers',
      )
    }
  },
)

export const CreateBrokerIdentifier = createAsyncThunk<
  BrokerIdentifier,
  CreateBrokerIdentifierRequest
>(`${SLICE_NAME}/create`, async (payload) => {
  try {
    const response = await BrokerIdentifiersApi.createIdentifier(payload)
    return response.data
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || error?.message || 'Failed to create identifier',
    )
  }
})

export const DeleteBrokerIdentifier = createAsyncThunk<void, DeleteBrokerIdentifierRequest>(
  `${SLICE_NAME}/delete`,
  async (payload) => {
    try {
      await BrokerIdentifiersApi.deleteIdentifier(payload)
    } catch (error) {
      throw new Error(
        error?.response?.data?.message || error?.message || 'Failed to delete identifier',
      )
    }
  },
)
